<template>
  <v-container>
    <v-layout v-if="settingsStore.licensesLoading">
      <v-spacer />
      <v-progress-circular indeterminate />
      <v-spacer />
    </v-layout>
    <ErrorDisplay
      v-else-if="settingsStore.licensesError"
      :message="settingsStore.licensesError?.message"
      :loading="settingsStore.licensesLoading"
      @retry="settingsStore.fetchLicences"
    />
    <AppDashboard v-else :modules="modules" />
  </v-container>
</template>

<script lang="ts" setup>
import AppDashboard from '@/components/AppDashboard.vue';
import ErrorDisplay from '@/components/ErrorDisplay.vue';
import {useSettings} from '@/store/settings';
import {DashboardModule, generateModule} from '@/util/dashboard';

const settingsStore = useSettings();

const modules: DashboardModule[] = [
  generateModule('crm'),
  generateModule('followup_module'),
  generateModule('picklist'),
  generateModule('order'),
  generateModule('inventory'),
  generateModule('suggestion'),
  generateModule('correction'),
  generateModule('umbuchung'),
  generateModule('article'),
];

defineExpose({
  AppDashboard,
  ErrorDisplay,
  modules,
  settingsStore,
});
</script>
